import { handlePromise } from "../apiControllers/helpers";
import Env from "../../Environments";
import { apiUrls } from "../../constants/apiUrls";

export const UserStatesAPI = async (params) => {
  const apiPayload = {
    method: "GET",
    params,
    url: Env.getLcoBasePath() + apiUrls.userStates,
    useParentKey: true
  };

  return handlePromise(apiPayload);
};

export const getPartnershipOboardingStatus = async () => {
  const apiPayload = {
    method: "GET",
    url: Env.getTeamOnboardUrl() + apiUrls.partnershipTaskStatus
  };
  return handlePromise(apiPayload);
};
